﻿export interface IClcScoresSummary {
    id: number;
    alias: string;
    clc: number;
    fclc: number;
    fndd: number;
    ndd: number;
    etmp: number;
    pmpc: number;
    htmp: number;
    matchFailures: number;
    ncs: string;
    rdn: number;
    fetmp: number;
    fpmpc: number;
    fhtmp: number;
    fncs: number;
    htmd: number;
    fhtmd: number;
    surgDeclines: number;
    uclc: number;
    clco: number;
    clct: number;
}